import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { StateController } from '../../../helpers/state/state-management/state-controller';
import { TextField } from '@material/mwc-textfield';
import topicData from '../../../helpers/state/topic-data';

@customElement('rename-map')
export class RenameMap extends LitElement {

	@property({ type: Boolean })
    open: boolean = false;

	@query('#mapTitle')
    mapTitleElement!: TextField;

	@query('#mapSubtitle')
   	mapSubtitleElement!: TextField;

	private readonly bindTopicState = new StateController(this, topicData);

	async updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has('open')) {
            await this.updateLayout();
        }
    }

	async updateLayout() {
		if (this.open) {
			await this.mapTitleElement?.layout();
			await this.mapSubtitleElement?.layout();
		}
	}

	async onChangeMapTitle(e: Event) {
		const mapTitle = (e.target as HTMLInputElement).value;

		await topicData.fetchAndUpdateTopicData({
			name: mapTitle
		}, 'rename');
	}

	async onChangeMapSubTitle(e: Event) {
		const mapSubTitle = (e.target as HTMLInputElement).value;

		await topicData.fetchAndUpdateTopicData({
			creator: mapSubTitle
		}, 'rename');
	}

    render() {
        return html`
			<proxi-textfield
				outlined
				id="mapTitle"
				class="input"
				label="Map Title"
				value="${topicData.name ?? ''}"
				charcounter="internal"
				@change=${this.onChangeMapTitle}
				maxlength="35"
				required>
			</proxi-textfield>

			<proxi-textfield
				outlined
				id="mapSubtitle"
				class="input"
				label="Map Subtitle"
				value="${topicData.topic?.creator ?? ''}"
				charcounter
				@change=${this.onChangeMapSubTitle}
				maxlength="70">
			</proxi-textfield>
		`;
    }

    static get styles() {
        return css`
		    .input {
                width: 100%;
                padding: auto 5px;
            }

			.header-text-label {
                margin: 10px 0;
            }
        `;
    }
}
